import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api, { getErrorMessage } from '../../../../../services/api';

/**
 * Repartir los expedientes marcados entre el equipo, sin entrar uno a uno
 * (docs/asignar-equipo-en-bloque-plan.md):
 *   - Asignar: se añade la persona, sin quitar a quien ya los llevaba;
 *   - Solo a esta persona: queda ella sola;
 *   - Quitar: se le quitan a ella.
 * Lo que el servidor no puede hacer (un expediente de otra empresa) lo salta y lo dice.
 */
const ACCIONES = [
  { mode: 'add', label: 'Asignar', hecho: (n, p) => `${n} expedientes asignados a ${p}` },
  { mode: 'replace', label: 'Solo a esta persona', hecho: (n, p) => `${n} expedientes quedan solo con ${p}` },
  { mode: 'remove', label: 'Quitar', hecho: (n, p) => `${p} ya no lleva ${n} expedientes` },
];

export const personName = p => `${p.username || ''} ${p.userlastname || ''}`.trim() || p.usermail || 'Sin nombre';

function BulkAssignBar({ selectedIds, team, onDone }) {
  const [memberId, setMemberId] = useState('');
  const [sending, setSending] = useState(false);
  const n = selectedIds.length;
  if (!n) return null;

  const ejecutar = async accion => {
    if (!memberId) {
      toast.error('Elige a quién');
      return;
    }
    setSending(true);
    try {
      const { data } = await api.post('/expedient-team/assign', {
        expedient_ids: selectedIds,
        team_member_id: memberId,
        mode: accion.mode,
      });
      const { done, skipped } = data.data;
      const persona = team.find(p => String(p._id) === memberId);
      toast.success(accion.hecho(done.length, persona ? personName(persona) : 'esa persona'));
      if (skipped.length) {
        toast.info(`${skipped.length} no se pudieron: ${[...new Set(skipped.map(s => s.reason))].join(', ')}`, {
          autoClose: 8000,
        });
      }
      onDone?.();
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className='mb-3 flex flex-wrap items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-2 text-sm text-blue-900'
      role='region'
      aria-label='Repartir entre el equipo'
    >
      <span className='font-medium'>Repartir {n} seleccionados</span>
      <select
        aria-label='Persona del equipo'
        value={memberId}
        onChange={e => setMemberId(e.target.value)}
        className='rounded-lg border-blue-300 text-sm'
      >
        <option value=''>Elige a quién…</option>
        {team.map(p => (
          <option key={p._id} value={p._id}>
            {personName(p)} ({p.userrole === 'gestor' ? 'gestor' : 'operador'})
          </option>
        ))}
      </select>
      {ACCIONES.map(a => (
        <button
          key={a.mode}
          type='button'
          disabled={sending}
          onClick={() => ejecutar(a)}
          className={
            a.mode === 'add'
              ? 'px-3 py-1.5 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 disabled:opacity-60'
              : 'px-3 py-1.5 rounded-lg border border-blue-300 text-blue-900 font-medium hover:bg-blue-100 disabled:opacity-60'
          }
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}

export default BulkAssignBar;
